// src/beta/hooks/useStoryReaderKeys.ts
import { useEffect } from 'react';

interface UseStoryReaderKeysOptions {
  onNext: () => void;
  onPrev: () => void;
  onClose: () => void;
}

/** Document-level keydown listener for the StoryReader page.
 *  - Escape → onClose
 *  - ArrowRight → onNext
 *  - ArrowLeft → onPrev
 *  Registered ONCE at the page level; slides do not register their own. */
export function useStoryReaderKeys({ onNext, onPrev, onClose }: UseStoryReaderKeysOptions) {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
      else if (e.key === 'ArrowRight') onNext();
      else if (e.key === 'ArrowLeft') onPrev();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onNext, onPrev, onClose]);
}
